// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsImmersion_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s12IconSvg = html `<svg viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7 7.375C7 7.25388 6.9898 7.12851 6.97065 7H7.97872C7.99261 7.12568 8 7.25088 8 7.375C8 8.82475 7.10457 10 6 10V9C6.17371 9 6.4017 8.91004 6.61878 8.62511C6.83649 8.33937 7 7.90071 7 7.375Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2 7.5C2 4.91426 4.1832 2.05563 5.32378 0.738609C5.72706 0.272939 6 0 6 0C6 0 6.27294 0.272939 6.67622 0.738609C7.8168 2.05563 10 4.91426 10 7.5C10 9.98528 8.20914 12 6 12C3.79086 12 2 9.98528 2 7.5ZM9 7.5C9 9.54698 7.54938 11 6 11C4.45062 11 3 9.54698 3 7.5C3 6.07539 3.84065 4.41768 4.82091 3.00856C5.24015 2.4059 5.66088 1.88239 6 1.48588C6.33912 1.88239 6.75985 2.4059 7.17909 3.00856C8.15935 4.41768 9 6.07539 9 7.5Z" class="svg-bg"/>
</svg>
`;
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9 9.625C9 9.44181 8.97013 9.23118 8.91492 9H10.444C10.4802 9.21514 10.5 9.42454 10.5 9.625C10.5 11.489 9.38071 13 8 13V11.5C8.10429 11.5 8.31977 11.4462 8.56243 11.1186C8.80491 10.7913 9 10.2681 9 9.625Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M2.5 10C2.5 7.26435 5.07255 3.59324 6.69885 1.54576C7.45049 0.59947 8 0 8 0C8 0 8.54951 0.59947 9.30115 1.54576C10.9275 3.59324 13.5 7.26435 13.5 10C13.5 13.3137 11.0376 16 8 16C4.96243 16 2.5 13.3137 2.5 10ZM11.5 10C11.5 12.3765 9.77274 14 8 14C6.22726 14 4.5 12.3765 4.5 10C4.5 9.41565 4.71347 8.59575 5.1775 7.58331C5.62855 6.59921 6.24842 5.57803 6.89808 4.63306C7.27485 4.08504 7.65301 3.57507 8 3.12735C8.34699 3.57507 8.72515 4.08504 9.10192 4.63306C9.75158 5.57803 10.3714 6.59921 10.8225 7.58331C11.2865 8.59575 11.5 9.41565 11.5 10Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M17 15.0005C17 18.3142 14.7614 21.0005 12 21.0005V19.0005C13.3309 19.0005 15 17.5666 15 15.0005C15 14.7127 14.9562 14.3773 14.8672 13.9995H16.908C16.9676 14.3434 17 14.6784 17 15.0005Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M4 15C4 10.5305 8.43914 4.3964 10.7039 1.55772C11.4794 0.585635 12 0 12 0C12 0 12.5206 0.585635 13.2961 1.55772C15.5609 4.3964 20 10.5305 20 15C20 19.9706 16.4183 24 12 24C7.58172 24 4 19.9706 4 15ZM18 15C18 19.094 15.0988 22 12 22C8.90124 22 6 19.094 6 15C6 13.9031 6.37738 12.5128 7.07762 10.9373C7.76584 9.38878 8.70088 7.80423 9.6641 6.3594C10.4917 5.11804 11.3221 4.00643 12 3.14281C12.6779 4.00643 13.5083 5.11804 14.3359 6.3594C15.2991 7.80423 16.2342 9.38878 16.9224 10.9373C17.6226 12.5128 18 13.9031 18 15Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsImmersion is a generated icon component.
 */
let IconRmsImmersion = IconRmsImmersion_1 = class IconRmsImmersion extends IconBaseElement {
    render() {
        return html `${IconRmsImmersion_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsImmersion.icons = new Map([
    ['s8', _s12IconSvg],
    ['s12', _s12IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconRmsImmersion = IconRmsImmersion_1 = __decorate([
    customElement('zui-icon-rms-immersion')
], IconRmsImmersion);
export { IconRmsImmersion };
